import React, { createContext, useState } from 'react';
import axios from 'axios';
import { useAsyncEffect, wrap } from '@hilma/tools';
import { OpeningDate } from '../types';

export const OpeningDatesContext = createContext<OpeningDate[] | null>(null);

const OpeningDatesProvider: React.FC = ({ children }) => {

    const [openingDates, setOpeningDates] = useState<OpeningDate[] | null>(null);

    useAsyncEffect(async () => {
        const response = await axios.get('/api/opening-date/get-opening-date');
        setOpeningDates(response.data);
    }, []);

    return wrap(
        [OpeningDatesContext.Provider, { value: openingDates }]
    )(children) as React.ReactElement;
}

export default OpeningDatesProvider;